<app-bottom-container [title]="'SIGNIN.TITLE' | transloco"
  [hasLogo]="true">
  <!--content-->
  <form content
    [formGroup]="loginForm"
    class="signin-form-content flex-column justify-start align-stretch"
    (ngSubmit)="onSignInClick()">
    <!-- Email-->
    <mat-form-field class="signin-field">
      <input type="email"
        formControlName="email"
        matInput
        [appAutofocus]="true"
        [placeholder]="'SIGNIN.EMAIL' | transloco"
        autocomplete="off" />
        <mat-icon matSuffix
          color="accent"
        svgIcon='at'></mat-icon>
        @if (submitted && loginForm.controls['email'].hasError('required')) {
          <mat-error>
          {{ "SIGNIN.ERRORS.EMAIL_REQUIRED" | transloco }}</mat-error>
        }
        @if (submitted && loginForm.controls['email'].hasError('email')) {
          <mat-error>
          {{ "SIGNIN.ERRORS.EMAIL_FORMAT" | transloco }}</mat-error>
        }
      </mat-form-field>

      <!-- Password-->
      <mat-form-field class="signin-field">
        <input matInput
          formControlName="password"
          [placeholder]="'SIGNIN.PASSWORD' | transloco"
          [type]="showPassword ? 'text' : 'password'"
          autocomplete="off" />
          <mat-icon matSuffix
            color="accent"
            class="show-password-icon"
            (click)="showPassword = !showPassword"
          [svgIcon]="showPassword ? 'unlock' : 'lock'"></mat-icon>
          @if (submitted) {
            <mat-error>{{ "SIGNIN.ERRORS.PASSWORD_REQUIRED" | transloco }}</mat-error>
          }
        </mat-form-field>

        <!-- Forgot password -->
        <div class="forgot-password"
          matButton>
          <a mat-button
          [routerLink]="[forgotPasswordLink]">{{"SIGNIN.FORGOT_PASSWORD" | transloco }}</a>
        </div>

        <!-- Buttons-->
        <div class="signin-buttons flex-column gap-10">
          <button type="submit"
            class="full-width"
            mat-flat-button
            color="accent"
            [disabled]="disabled">
            {{ "SIGNIN.SIGN_IN" | transloco }}
            @if (disabled) {
              <app-loader></app-loader>
            }
          </button>
        </div>

        <div class="signup-link">
          <span>{{ "WELCOME.ASK_SIGNUP" | transloco }}</span>
          <a mat-button
            color="primary"
            class="light-color"
          (click)="onSignUpClick()">{{ "WELCOME.SIGNUP" | transloco }}</a>
        </div>

        <div class="buttons-row">
          @if (showGoBackButton) {
            <button type="button"
              class="main-button go-back-button"
              mat-button
              (click)="onGoBack()">
              <mat-icon>keyboard_arrow_left</mat-icon>&nbsp;{{ "COMMON.BACK" | transloco }}
            </button>
          }
          @if (showGoToMenuButton) {
            <button type="button"
              class="main-button go-to-menu-button"
              mat-button
              (click)="onGoToMenu()">
              {{ "SIGNIN.GO_TO_MENU" | transloco }}&nbsp;<mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          }
        </div>

      </form>
    </app-bottom-container>
